const Terms250410 = () => {
	return (
		/* eslint prettier/prettier: off */
		<div className="terms-content">
			<div className="terms-box">
				<h4 className="terms-title">제 1 조 (목적)</h4>
				<p>
					본 약관은 주식회사 핑거 (이하 '회사')가 운영하는 웹 기반 사이트(
					<a
						href="https://www.stella-erp.com/"
						className="text-link"
						target="_blank"
						title="새창 열림"
						rel="noreferrer">
						www.stella-erp.com
					</a>
					)(이하 '사이트')를 통해 제공하는 "스텔라 서비스" 이용과 관련하여, 회사와 회원 간 권리와 의무 및 책임사항 등
					기타 제반사항을 규정함을 목적으로 합니다.
				</p>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 2 조 (용어의 정의)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
						<ol className="terms-depth">
							<li className="depth">
								<span>1)</span>"스텔라 서비스(이하 ‘서비스’)"라 함은 회사가 웹기반으로 제공하는 '스타트업과 성장기업을
								위한 올인원 비즈니스웨어 플랫폼'을 의미합니다.
							</li>
							<li className="depth">
								<span>2)</span>"회원"이라 함은 회사의 서비스에 접속하여 본 약관에 따라 회사와 서비스 이용계약을 체결하고
								회사가 제공하는 서비스를 이용하는 개인사업자 또는 법인사업자를 의미합니다.
							</li>
							<li className="depth">
								<span>3)</span>“회원”이라 함은 다음과 같이 구분됩니다.
								<ol className="terms-depth">
									<li className="depth ko">
										<span>가.</span>이용사: 서비스를 이용하는 개인사업자 및 법인사업자
									</li>
									<li className="depth ko">
										<span>나.</span>관리자: 이용사의 소속 구성원으로 이용사를 대표하여 사용자 별 계정 부여 및 서비스
										이용을 승인하고, 사용자의 서비스 이용에 대한 관리권한과 운영을 책임지는 자를 의미합니다.
									</li>
									<li className="depth ko">
										<span>다.</span>사용자: 이용사의 소속 구성원으로 관리자가 사용을 승인한 자로 관리자가 부여한 기능만
										제한 적으로 이용할 수 있는 자
									</li>
								</ol>
							</li>
							<li className="depth">
								<span>4)</span>부가서비스: 서비스 제공 사이트 내에서 회원의 선택에 따라 유료 결제의 방식으로 구매하여
								이용할 수 있는 회사 또는 제3자의 서비스를 말합니다.
							</li>
							<li className="depth">
								<span>5)</span>“포인트”라 함은 회원이 회사 또는 제3자가 제공하는 부가서비스를 이용하기 위하여 정해진
								방법 으로 충전하여 현금과 동일하게 사이트에서 이용할 수 있는 결제수단입니다.
							</li>
							<li className="depth">
								<span>6)</span>제3자 전문가 서비스: 회사가 제공하는 서비스와는 별개로 회사 이외의 제3 자가 회사와의
								제휴, 협업계약에 따라 서비스 내에서 연계하여 제3자가 회원에게 제공하는 서비스
							</li>
						</ol>
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 3 조 (이용약관의 효력 및 적용과 변경)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>본 약관은 서비스를 이용하기 위해 회원이 사이트에 접속하여 약관에 동의를 한 다음 회원가입신청
						을 하고, 회사가 이러한 신청에 대하여 승낙함으로써 효력을 발휘합니다. 본 약관의 공시는 회원이 알 수 있도록
						사이트나 기타의 방법으로 회원에게 공지합니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 합리적인 사유가 발생할 경우 관련 법령에 위배되지 않는 범위 내에서 약관을 개정할 수 있
						습니다. 개정된 약관은 사이트를 통해 공지하거나 기타의 방법으로 약관 적용 7일전부터 적용 전일까지 적용일자 및
						변경사유를 회원에게 공지함으로써 그 효력이 발생합니다. 다만, 회원에게 불리하게 약관 내용을 변경하는 경우에는
						변경될 약관, 적용일자 및 변경사유를 최소한 30일 이상의 사전 유예기간을 두고 고지합니다. 이 경우 회사는 개정
						전 내용과 개정 후 내용을 명확하게 비교하여 회원이 알기 쉽도 록 표시합니다.
					</li>
					<li className="depth">
						<span>3.</span>회원 전자메일 주소 오류 및 변경 등으로 인하여 개별 통지가 어려운 경우 본 약관에 의한 공지를
						함으로써 개별 통지한 것으로 간주합니다. 변경된 약관에 대한 정보를 알지 못해 발생하는 회원의 피해 는 회사에서
						책임지지 않습니다. .
					</li>
					<li className="depth">
						<span>4.</span>회원은 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 회원 탈퇴를 요청할 수
						있습니다. 회원이 그러한 조치를 취하지 않은 경우 개정 약관에 동의한 것으로 봅니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 4 조 (약관 외 준칙)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 필요한 경우 기타 유·무료 서비스 내의 운영원칙 또는 개별약관(이하 '서비스 별 약관'이 라
						합니다)을 정할 수 있으며, 본 약관과 서비스 별 약관의 내용이 상충되는 경우에는 서비스 별 약관 의 내용을
						우선하여 적용합니다.
					</li>
					<li className="depth">
						<span>2.</span>본 약관에서 정하지 않은 사항과 본 약관의 해석에 관하여는 정보통신망 이용촉진 및 정보보호 등
						에 관한 법률, 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률 및 기타 관계법 령 또는
						상관례에 따릅니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 5 조 (서비스 이용 계약 체결)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span> 이용계약은 회원이 약관의 내용에 대하여 동의를 한 다음 회사가 규정한 양식과 절차에 따라 이용
						신청을 하고 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
					</li>
					<li className="depth">
						<span>2.</span>제1항에 따른 신청에 있어 회사는 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을
						요청할 수 있으며, 서비스 제공을 위해 필요한 경우 회원에게 요청하는 회원정보 및 기타정보 항목을 추가하거나
						변경할 수 있습니다.
					</li>
					<li className="depth">
						<span>3.</span>서비스를 이용하고자 하는 회원은 회사에서 요청하는 제반 정보(개인정보 처리방침에 따라 처리 및
						수집하는 개인정보의 항목 등)를 제공하여야 합니다.
					</li>
					<li className="depth">
						<span>4.</span>회원은 반드시 회원 본인의 정보를 제공하여야만 서비스를 이용할 수 있으며, 타인의 정보를 도용
						하거나 허위의 정보를 등록하는 등 본인의 정확한 정보를 등록하지 않은 회원은 서비스 이용과 관련하 여 여타의
						권리를 주장할 수 없으며, 관계 법령에 따라 처벌받을 수 있습니다. 또한 이로 인해 제3자에 게 야기한 손해를
						배상할 책임이 있으며, 회사는 허위의 정보를 기재한 회원의 서비스 이용 자격을 제 한할 수 있습니다.
					</li>
					<li className="depth">
						<span>5.</span>회사는 회원의 이용신청에 대하여 승낙함을 원칙으로 합니다. 다만, 다음 각 호에 해당하는 회원의
						서비스 이용신청에 대해서는 승인을 거절하거나 사후에 이용계약을 해지할 수 있습니다.
						<ol className="terms-depth">
							<li className="depth">
								<span>1)</span> 실명이 아니거나 타인의 명의를 이용한 경우
							</li>
							<li className="depth">
								<span>2)</span> 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
							</li>
							<li className="depth">
								<span>3)</span> 사이트를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우
							</li>
							<li className="depth">
								<span>4)</span> 회원이 서비스의 정상적인 제공을 저해하거나 다른 회원의 서비스 이용에 지장을 줄 것으로
								예상 되는 경우
							</li>
							<li className="depth">
								<span>5)</span> 기타 회사가 정한 서비스 정책 및 업무처리 기준에 위배된 경우
							</li>
						</ol>
					</li>
					<li className="depth">
						<span>6.</span>회원가입계약의 성립 시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.
					</li>
					<li className="depth">
						<span>7.</span>회사의 승낙의 의사표시에는 이용신청에 대한 서비스의 내용, 이용방법, 이용료 및 기타 이용조건
						등에 대한 정보를 포함하여야 합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 6 조 (회원 정보의 변경)</h4>
				<ul className="terms-depth">
					<li className="depth">
						<span>1.</span>회원은 개인정보관리화면을 통해서 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>회원은 회원가입 시 기재한 개인정보의 내용에 변경이 발생한 경우, 즉시 변경사항을 정정하여 회
						사에 알려야 합니다.
					</li>
					<li className="depth">
						<span>3.</span>회원이 전 항의 내용을 이행하지 않아 발생한 불이익에 대하여 회사는 책임을 지지 않습니다.
					</li>
				</ul>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 7 조 (회원에 대한 통지)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 본 약관에 별도 규정이 없는 한 회원이 등록한 전자우편주소, 휴대전화번호로 이메일, 문자
						메시지 등 기타 통신수단을 이용하여 회원에게 통지할 수 있습니다. 회원이 전자우편주소, 휴대전화번 호 정보를
						허위로 제출 또는 등록하거나, 변경된 정보를 수정 또는 회사에 고지하지 않은 경우 회사가 회원이 사전에 제출
						또는 등록한 정보로 발송한 때에 회원에게 당해 통지가 도달한 것으로 합니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 전체 또는 다수 회원에 대한 통지의 경우 사이트 공지사항에 게시하여 제1항의 통지에 갈
						음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통 지를 합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 8 조 (회원의 아이디 및 비밀번호 관리 의무)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회원의 아이디와 비밀번호에 관한 관리책임은 회원에게 있으며 이를 제3자가 이용하도록 하여서는
						안 됩니다. 회원의 고의 또는 관리 소홀 등의 과실로 인하여 아이디 또는 비밀번호가 유출되어 발생한 제3자의
						도용, 부정사용 등에 대해서 회사는 책임을 지지 않습니다.
					</li>
					<li className="depth">
						<span>2.</span>회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회
						사에 통지하고 회사의 안내에 따라야 하며, 회사에 제3자 도용, 부정사용 사실을 통지하지 않거나 통지 한 경우에도
						회사의 안내에 따르지 않아 발생한 불이익에 대해서 회사는 어떠한 책임도 부담하지 않습 니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 9 조 (서비스 제공, 변경 및 중단)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
					</li>
					<li className="depth">
						<span>2.</span>서비스는 회사가 운용하는 클라우드 기반의 웹사이트를 기반으로 제공되며, 또한 공중망(인터넷을
						통한 네트워크 서비스)을 통해서만 제공합니다. .
					</li>
					<li className="depth">
						<span>3.</span>서비스는 특정 인터넷 브라우저와 버전을 기준으로 제공되며 브라우저와 버전은 필요에 따라 변경
						될 수 있습니다. 기준 외 브라우저나 버전에서는 서비스의 일부 또는 전체가 작동하지 않을 수 있습니 다.
					</li>
					<li className="depth">
						<span>4.</span>회원은 회사가 제공하는 서비스를 약관, 운영정책 등 회사가 정한 규정에 따라 이용할 수 있습니다.
					</li>
					<li className="depth">
						<span>5.</span>회사는 회원에게 제공하는 서비스에 대한 변경, 유지, 보수에 관한 포괄적인 권한을 가지며, 서비스
						의 운영상 필요한 경우 제공하고 있는 서비스의 전부 또는 일부를 상시적으로 수정 및 추가, 중단 등 변경할 수
						있습니다. 이 경우 추가, 변경된 서비스의 내용 및 시행일자를 미리 사이트에 게시하거나 회 원에게 개별
						통지합니다.
					</li>
					<li className="depth">
						<span>6.</span>회사는 컴퓨터 등 정보통신설비의 보수점검, 노후 및 고장에 의한 교체, 통신망의 두절 또는 기타
						운영상 상당한 이유가 있는 경우 서비스 제공을 일시적으로 중단할 수 있습니다. 단, 회사는 회원에게 사전 통지
						또는 공지함을 원칙으로 하며, 부득이한 경우에는 사후 통지할 수 있습니다.
					</li>
					<li className="depth">
						<span>7.</span>회사는 제5항, 제6항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 회원 또는 제3자가
						입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아 니합니다.
					</li>
					<li className="depth">
						<span>8.</span>회사가 사업종목의 전환, 사업의 포기, 업체 간의 통합, 회사의 업무상·기술상의 사유 또는 천재지
						변이나 비상사태 등 부득이한 경우 등의 이유로 서비스를 제공할 수 없게 되는 경우, 회사는 제7조 (회 원에 대한
						통지)에서 정한 방법으로 회원에게 미리 통지하고 서비스를 종료할 수 있으며, 당초 회사에 서 제시한 조건에 따라
						회원에게 보상합니다. 다만, 회사가 보상기준 등을 고지하지 아니한 경우에는 회원의 마일리지 또는 적립금 등을
						사이트에서 통용되는 통화가치에 상응하는 재화로 회원에게 지급합 니다.
					</li>
					<li className="depth">
						<span>9.</span>회사는 서비스와 외부 결제대행업체의 결제시스템을 연결해 회원이 서비스 이용요금을 결제할 수
						있도록 결제시스템을 제공할 수 있습니다. 단, 결제대행업체의 시스템 장애 등 회사에게 책임 없는 사 유로
						회원에게 손해가 발생한 경우 회사는 면책됩니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 10 조 (서비스 이용의 제한 및 정지)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 회원이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우 제7조 (회원에
						대한 통지)에서 정한 방법을 통하여 그 시정 또는 개선을 요구할 수 있고, 귀책 당사자의 시정 또는 조 치가 없을
						경우 서비스 이용을 제한하거나 정지할 수 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 전항에도 불구하고 주민등록법을 위반한 명의도용 및 결제도용, 저작권법을 위반한 불법프
						로그램의 제공 및 운영방해, 정보통신망 이용촉진 및 정보보호 등에 관한 법률을 위반한 불법통신, 해 킹,
						악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지 를 할 수
						있습니다. 본 항에 따른 서비스 영구이용정지 시 서비스 내의 혜택 및 권리 등도 모두 소멸되 며 회사는 이에 대해
						별도로 보상하지 않습니다.
					</li>
					<li className="depth">
						<span>3.</span>회사가 회원자격을 제한·정지시킨 후 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가
						시정되지 아니하는 경우 회사는 회원자격을 상실시킬 수 있습니다.
					</li>
					<li className="depth">
						<span>4.</span>회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등
						록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 11 조 (회사의 의무)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적
						으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 서비스 제공과 관련하여 알고 있는 회원의 개인정보를 회원의 승낙 없이 제3자에게 누설,
						배포하지 않습니다. 다만, 관계법령에 의한 관계기관으로부터의 요청 등 법률의 규정에 따른 적법한 절 차에 의한
						경우에는 그러하지 않습니다.
					</li>
					<li className="depth">
						<span>3.</span>회사는 관련된 법규 및 전문가 기준 준수, 원활한 서비스 제공 및 홍보 목적으로 이용사의
						사업자명과 서비스 이용 사실을 제3자에게 제공하는 방법으로 활용할 수 있습니다.
					</li>
					<li className="depth">
						<span>4.</span>회사는 회원이 안전하게 인터넷 서비스를 이용할 수 있도록 회원의 개인정보(신용정보 포함)보호를
						위한 보안시스템을 갖추어야 합니다.
					</li>
					<li className="depth">
						<span>5.</span>회사는 서비스에 대하여 표시·광고의 공정화에 관한 법률 제3조 소정의 부당한 표시·광고 행위를
						함으로써 회원이 손해를 입은 때에는 이를 배상할 책임을 집니다.
					</li>
					<li className="depth">
						<span>6.</span>회사는 회원이 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.
					</li>
					<li className="depth">
						<span>7.</span>회사는 ‘부가 서비스’ 제공을 위하여 회사가 아닌 제3자의 서비스와 시스템을 연결해 회원에게
						부가서비스를 제공할 수 있습니다. 단, 제3자의 시스템 장애 등 회사에게 책임 없는 사유로 회원에게 손해가 발생한
						경우 회사는 면책됩니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 12 조 (회원의 의무)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회원은 본 약관 및 관계 법령을 준수하여야 하며, 기타 회사의 업무 수행에 지장을 초래하는 행위
						를 하여서는 안됩니다.
					</li>
					<li className="depth">
						<span>2.</span>회원은 다음 각 호에 해당하는 행위를 하여서는 안 됩니다.
						<ul className="terms-depth">
							<li className="depth">
								<span>1)</span>서비스 이용 신청 또는 서비스 내용 변경 시 허위내용을 등록하는 행위
							</li>
							<li className="depth">
								<span>2)</span>타인의 정보나 명의를 도용하거나 부정하게 사용하는 행위
							</li>
							<li className="depth">
								<span>3)</span>다른 회원의 개인정보를 동의 없이 수집, 저장, 공개하는 행위
							</li>
							<li className="depth">
								<span>4)</span>회사가 게시한 정보를 변경하거나 제3자에게 제공하는 행위
							</li>
							<li className="depth">
								<span>5)</span>회사 혹은 제3자의 저작권 등 기타 지식재산권에 대한 침해하는 행위
							</li>
							<li className="depth">
								<span>6)</span>회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위
							</li>
							<li className="depth">
								<span>7)</span>외설, 폭력적인 메시지, 화상, 음성 기타 미풍양속에 반하는 내용의 정보를 유포하는 행위
							</li>
							<li className="depth">
								<span>8)</span>회사의 동의 없이 본 약관의 목적 범위를 벗어나 영리를 목적으로 서비스를 이용하는 행위
							</li>
							<li className="depth">
								<span>9)</span>컴퓨터 소프트웨어 ∙ 하드웨어 ∙ 전기통신 장비의 정상적인 가동을 방해 ∙ 파괴할 목적으로
								고안된 소프트웨어 바이러스, 악성코드 등 관련 법령에 의하여 전송 또는 게시가 금지되는 정보를 이용 또는
								전송하는 행위
							</li>
							<li className="depth">
								<span>10)</span>기타 불법하고 부당한 행위
							</li>
						</ul>
					</li>
					<li className="depth">
						<span>3.</span>회원이 서비스를 이용하여 회원의 재무정보 혹은 제 3 자 정보 (이용사의 임직원 개인정보 포함)를
						수집, 처리, 관리, 이용하는 경우 회원은 관련법 및 규정을 준수하여 해당 개인정보를 수집, 이용 등 관리하고
						보호해야 하며, 회사는 회원의 귀책으로 발생하는 정보 유출 등의 결과, 손실 또는 손해에 대하여 책임을 지지
						않습니다.
					</li>
					<li className="depth">
						<span>4.</span>회원은 회원이 적법하게 라이선스를 취득한 제3자 IP를 회원 전용 서비스 환경에 반영 요청할 수
						있으나 회사의 판단에 따라 기술적 등 사유로 인해 적합하지 않다고 판단될 경우 요청은 거절될 수 있습니다. 또한
						요청이 수락되더라도, 회사는 제3자 IP 및 제3자 IP가 생성한 산출물 등에 관한 어떠한 책임이 없습니다.
					</li>
					<li className="depth">
						<span>5.</span>‘제3자 전문가 서비스’와 관련하여 회원과 제3자 간에 발생한 거래나 분쟁에 대하여 회사는 어떠한
						책임이 없습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 13 조 (이용요금 납부 및 환불)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>서비스의 요금은 기본 서비스 요금, 확장 서비스 요금, 부가 서비스 요금 등을 말합니다.
					</li>
					<li className="depth">
						<span>2.</span>회사가 제공하는 서비스 이용과 관련하여 회원이 납부하여야 할 가입비, 서비스 이용요금 및 납부
						방법은 홈페이지에 게재한 바에 따릅니다.
					</li>
					<li className="depth">
						<span>3.</span>회사는 서비스의 내용 및 요금 등 관련 정책이 변경될 경우 홈페이지에 게시합니다.
					</li>
					<li className="depth">
						<span>4.</span>회사는 판매 촉진, 회원 유치 등의 목적을 위해 회사의 정책에 따라 가격 할인, 무료 이용기간
						제공, 가입비 면제 등 프로모션에 따른 혜택을 제공할 수 있습니다. 회원의 서비스 이용신청 내용이 회사 의
						프로모션 제공 조건에 부합하지 않는 경우 회사는 프로모션에 따른 혜택을 제공하지 않을 수 있으며, 회사는 그에
						대한 어떠한 책임도 부담하지 않습니다.
					</li>
					<li className="depth">
						<span>5.</span>회원은 회사가 안내하는 환불 정책 및 방법에 따라 서비스 이용요금에 대해 환불을 요구할 수
						있습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 14 조 (포인트)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 서비스 이용요금 지급 수단으로 포인트를 발행할 수 있고, 회원은 회사가 정하는 방법과 절
						차에 따라 회사로부터 포인트를 충전해 사용할 수 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>제1항과 별도로 회사는 회원에게 별도의 적립포인트를 제공할 수 있습니다.
					</li>
					<li className="depth">
						<span>3.</span>회원은 보유한 포인트를 타 회원에게 증여, 양도할 수 없습니다.
					</li>
					<li className="depth">
						<span>4.</span>포인트 차감 서비스로 분류된 부가서비스의 경우(전자세금계산서, 팩스 서비스 등) 서비스 이용에
						따른 포인트 사용시점에 포인트가 즉시 차감됩니다.
					</li>
					<li className="depth">
						<span>5.</span>충전포인트 소멸정책은 [대금결제 및 재화 등의 공급에 관한 기록: 5 년 (전자상거래 등에서의
						소비자보호에 관한 법률)]에 따라 보존합니다.
					</li>
					<li className="depth">
						<span>6.</span>충전포인트는 충전일 기준 5 년 이후 자동 소멸처리 됩니다.
					</li>
					<li className="depth">
						<span>7.</span>서비스 해지 시 충전포인트는 회원의 요청에 따라 환불되나, 적립포인트는 현금으로 환불되지 않고
						자동 소멸됩니다.
					</li>
					<li className="depth">
						<span>8.</span>포인트 반환에 관하여는 제17조 서비스 이용요금 등의 반환을 준용하고, 그 외 필요한 부분은
						회사가 별도로 정하는 바에 따릅니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 15 조 (서비스 이용요금 등의 지급)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회원은 다음 각 호의 방법 중 가능한 방법으로 서비스 이용요금을 결제할 수 있습니다. 단, 회사의
						정책 및 결제기관(카드사, CMS사 등)의 기준에 따라 회원의 월 누적 결제한도가 제한되어 있는 상태에서 해당
						회원의 서비스 이용요금이 당해 한도를 초과한 경우 서비스의 추가 이용이 제한될 수 있습니다.
						<ul className="terms-depth">
							<li className="depth">
								<span>1)</span>포인트 충전: 신용카드, 가상계좌
							</li>
							<li className="depth">
								<span>2)</span>자동 이체 결제: 1개월 단위로 결제(CMS 출금)
							</li>
							<li className="depth">
								<span>3)</span>기타: 무통장입금, 가상계좌
							</li>
						</ul>
					</li>
					<li className="depth">
						<span>2.</span>회원은 서비스 이용을 위한 서비스 이용요금 결제 시 회사가 정하는 범위 내에서 결제 수단과 결제
						방식을 선택할 수 있습니다.
					</li>
					<li className="depth">
						<span>3.</span>자동 이체 결제 방식이란, 일정 기간마다 회원이 사전에 승인한 일정한 결제 수단으로 서비스 이용
						요금을 자동으로 결제하는 방식을 말합니다. 회원이 회사가 정한 절차에 따라 자동 이체 결제 방식의 철회 의사를
						밝히지 않는 한 자동으로 이용계약이 갱신되고 결제가 이루어집니다. 매달 결제되는 가격 을 변경한 경우, 회원이
						변경된 가격 등을 확인하고 동의여부를 선택할 수 있도록 변경된 가격으로 전 자적 대금지급이 이루어지는 시점에서
						전자결제업자 등이 마련한 전자적 대금 결제창을 회원에게 제공 합니다.
					</li>
					<li className="depth">
						<span>4.</span>회원은 서비스 이용요금을 결제함에 있어 다음에 기재한 사유가 발생하지 않도록 유의하여야 합니
						다.
						<ul className="terms-depth">
							<li className="depth">
								<span>1)</span>회원 본인 외에 결제수단 사용을 금지합니다.
							</li>
							<li className="depth">
								<span>2)</span>회원은 결제수단의 비밀번호, 인증서 등의 유출로 인한 부정사용 또는 위변조 사고가 발생하지
								않도록 주의하여야 합니다. 특히 회원은 신용카드의 미서명, 관리소홀, 무단 대여나 양도 또는 담보제공으로
								인한 부정사용, 불법 현금대출, 위변조 사고 등이 발생하지 않도록 주의하여야 합니다.
							</li>
						</ul>
					</li>
					<li className="depth">
						<span>5.</span>회사는 서비스 이용요금 결제가 정상적으로 이루어지지 않은 경우 회원의 서비스 이용을 제한할 수
						있으며, 서비스 이용요금을 미납하는 등 회원의 귀책사유로 회사가 서비스 이용을 제한한 경우 회원에게 발생한
						손해에 대해서 회사는 면책됩니다.
					</li>
					<li className="depth">
						<span>6.</span>회사는 회사의 사정에 따라 결제 방식, 결제 수단을 추가, 삭제, 변경할 수 있으며, 사전에 그
						사유와 적용일자를 공지합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 16 조 (청약의 철회)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사가 제공하는 서비스는 콘텐츠산업법 및 콘텐츠이용자 보호지침에서 규정하는 청약철회가 불가
						능한 서비스입니다. 회사는 청약철회권의 제한을 위해 동법에 따라 다음 각 호 중 하나의 조치를 취하 여야 합니다.
						<ol className="terms-depth">
							<li className="depth">
								<span>①</span>청약의 철회가 불가능한 "유료서비스"에 대한 사실을 표시사항에 포함한 경우
							</li>
							<li className="depth">
								<span>②</span>시용상품을 제공한 경우
							</li>
							<li className="depth">
								<span>③</span>한시적 또는 일부이용 등의 방법을 제공한 경우
							</li>
						</ol>
					</li>
					<li className="depth">
						<span>2.</span>청약 철회에 따른 환불 등은 제13조 (이용요금의 납부 및 환불) 제18조 (서비스 이용요금 등의 반
						환) 및 콘텐츠이용자 보호지침 제12조에 따릅니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 17 조 (이용계약의 해지)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회원이 서비스의 이용해지를 원하는 경우 회원 본인이 온라인 또는 고객센터를 통해 직접 서비스
						해지를 신청하여야 합니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 회원의 이용계약 해지신청이 접수되면 별도의 채권 채무 관계가 있는지를 확인한 후 회사의
						절차에 따라 최종적으로 해지 처리합니다.
					</li>
					<li className="depth">
						<span>3.</span>회사는 회원이 다음 각 호에 해당할 경우에는 회원의 동의 없이 이용계약을 해지할 수 있으며 그
						사실을 회원에게 통지합니다. 다만, 회사가 긴급하게 해지할 필요가 있다고 인정하는 경우나 회원의 귀 책사유로
						인하여 통지할 수 없는 경우에는 지체 없이 사후 통지로 대체할 수 있습니다.
						<ol className="terms-depth">
							<li className="depth">
								<span>1)</span>회원이 제12조 (회원의 의무)를 포함한 본 약관을 위반하고 일정 기간 이내에 위반 내용을 해소
								하지 않는 경우
							</li>
							<li className="depth">
								<span>2)</span>회사의 서비스 제공목적 외의 용도로 서비스를 이용하거나 제3자에게 임의로 서비스를 임대한
								경 우
							</li>
							<li className="depth">
								<span>3)</span>제10조(서비스 이용의 제한 및 정지) 규정에 의하여 이용정지를 당한 이후 1년 이내에 이용정지
								사유가 재발한 경우
							</li>
							<li className="depth">
								<span>4)</span>회사의 이용요금 등의 납입청구에 대하여 회원이 이용요금을 체납할 경우
							</li>
							<li className="depth">
								<span>5)</span>1년간 서비스에 로그인 없이 사용하지 않고 남아있는 충전포인트가 없는 경우.
							</li>
							<li className="depth">
								<span>6)</span>금융기관의 지급거절, 해산, 회사정리, 파산 등의 절차가 개시되거나 이와 유사한 상황이
								발생한 경우
							</li>
							<li className="depth">
								<span>7)</span>기타 정상적인 서비스 운영에 방해가 된다고 회사가 판단한 경우
							</li>
						</ol>
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 18 조 (서비스 이용요금 등의 반환)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 회원이 지급한 이용요금의 과납 또는 오납이 있을 경우 회원에게 새로 발생하는 요금액이
						있는 경우 이를 우선 상계하고, 잔여금액을 반환합니다. 회사가 과소 청구한 요금에 대해서는 다음 달 에 합산하여
						청구합니다.
					</li>
					<li className="depth">
						<span>2.</span>연납 방식으로 요금을 납부중인 서비스에 대해 사용기간 중도에 해지 요청하는 경우, 전체 사용기
						간 중 해당월의 말일까지 서비스를 사용할 수 있으며, 다음월의 요금부터 환불 금액으로 산정합니다. 단, 회사가
						무상으로 제공한 서비스 이용기간은 잔여기간에 포함되지 않습니다
					</li>
					<li className="depth">
						<span>3.</span>월납 방식으로 요금을 납부중인 서비스에 대해 해당 월의 중도에 해지 요청하는 경우, 해지 당월
						요금은 전액 청구되며 해당 월의 말일까지 서비스를 사용할 수 있습니다.
					</li>
					<li className="depth">
						<span>4.</span>본 조에 따른 환불 시 환불과정에서 발생하는 제반 수수료, 비용 등은 회원이 부담함을 원칙으로
						합니다.
					</li>
					<li className="depth">
						<span>5.</span>회사의 책임 있는 사유로 과오금이 발생한 경우 사업자는 계약비용·수수료 등에 관계없이 과오금
						전액을 환급하여야 합니다. 다만 회원의 책임 있는 사유로 과오금이 발생한 경우, 회사는 과오금을 환 급하는데
						소요되는 비용을 합리적인 범위 내에서 공제하고 환급할 수 있습니다.
					</li>
					<li className="depth">
						<span>6.</span>회사는 본 조에 따른 환불금액을 중도 해지일을 기준으로 익월 말일까지 회원 명의 계좌로 입금하
						거나, 결제대행업체에게 대금 청구를 정지하거나 결제승인을 취소하도록 요청하는 등 환불에 필요한 조 치를
						이행합니다. 단, 회원이 회사에게 부담하는 금전지급채무가 있다거나 기타 회사에 부담하는 채무 이행을 지연하고
						있을 경우, 회사는 중도해지 요금 환불을 보류 또는 회원의 채무 변제에 우선 충당할 수 있습니다.
					</li>
					<li className="depth">
						<span>7.</span>신용카드 결제 후 결제를 취소하는 경우 환급 금액, 환급 방법과 환급일은 해당 신용카드 정책에
						따르며, 회사는 결제 취소에 필요한 조치를 하는 것 외에 환급에 관하여 책임을 부담하지 않습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 19 조 (서비스 이용 자료의 보관)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>서비스를 이용함에 있어 서비스 내 데이터의 보관 및 백업은 회원에게 그 의무가 있으며 회사가 이
						를 회원에게 제공할 의무는 없습니다. 회사는 회원에게 주기적으로 데이터를 백업받아 별도 저장하는 것을
						권장합니다. 회원의 과실이나 관리소홀로 인하여 발생하는 데이터의 분실, 누락에 대한 일체의 책 임은 회원에게
						있습니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 서비스 이용 해지 및 기타 사유로 회사가 회원에게 서비스 제공을 종료한 경우, 해당 회원의
						데이터를 보관할 의무는 없습니다.
					</li>
					<li className="depth">
						<span>3.</span>회사는 서비스 이력 확인 및 회원의 민원처리를 위하여 결제정보 등의 일부 데이터는 관련법령 및
						개인정보처리방침에 따라 일정기간 동안 별도로 보관할 수 있습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 20 조 (지식재산권 등)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사가 작성하여 제공하는 서비스에 관한 소유권 및 지식재산권은 회사에 귀속되며, 본 약관을 동
						의한 회원에게 회사는 서비스에 대한 사용권만을 부여합니다. 회원은 이를 양도, 판매, 담보제공 등의 처분행위를
						할 수 없습니다.
					</li>
					<li className="depth">
						<span>2.</span>회원은 서비스를 이용하여 얻은 정보를 회사의 사전 동의 없이 영리 목적으로 복제, 전송, 출판, 배
						포, 방송, 기타 방법에 의하여 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
					</li>
					<li className="depth">
						<span>3.</span>회원이 서비스를 이용하며 게재한 게시물에 대한 저작권은 게시한 회원에게 있습니다. 회사는 회원
						이 게재한 게시물에 대하여, 게재한 회원의 동의 없이 이를 영리적인 목적으로 사용하지 않습니다. 다 만, 회사는
						비영리목적으로 게시물을 사용할 수 있으며, 서비스 내에서의 게재권을 가집니다.
					</li>
					<li className="depth">
						<span>4.</span>회사는 제12조(회원의 의무)의 의무를 위반하는 내용을 담고 있는 게시물에 대하여 수정 또는 삭
						제할 권한을 갖습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 21 조 (개인정보의 보호)</h4>
				<p>
					회사는 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 이용에
					관해서는 관계 법령 및 회사의 개인정보 처리방침이 적용됩니다.
				</p>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 22 조 (정보보호)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 관계법령이 정하는 방법과 절차에 따라 회원의 정보를 회사가 유지·관리하는 시설에 저장
						하고 연산 처리할 수 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 회사와 회원을 보호하고, 서비스를 정상적으로 운영하기 위해 관계법령이 정하는 방법과
						절차에 따라 정보를 수집할 수 있습니다.
					</li>
					<li className="depth">
						<span>3.</span>회사와 회원은 서비스 이용 계약의 체결 및 이행과 관련하여 알게 된 상대방의 기술정보, 영업비
						밀, 세무·회계정보, 기타 사업과 관련된 정보를 본 계약의 이행을 위해서만 사용하여야 합니다. 이는 본 약관에
						따른 서비스 이용계약이 종료된 경우에도 유효합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 23 조 (정보 제공 및 광고게재)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 사이트에 서비스와 관련된 프로모션, 이벤트, 설문조사, 신규 서비스 소개 등 서비스 이용
						과 관련된 안내 또는 광고를 게재할 수 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>회원이 서비스 상에 게재되어 있는 광고를 이용하거나, 광고주의 판촉활동에 참여하는 등의
						방법으로 광고주의 서비스를 이용하는 것은 전적으로 회원과 광고주 간의 문제입니다. 만약 회원과 광고주 간에
						문제가 발생할 경우 당사자간에 직접 해결해야 하며, 이와 관련하여 회사는 어떠한 책임도 지지 않습니다.
					</li>
					<li className="depth">
						<span>3.</span>회원은 관련법령에 따라 정보의 수신이 강제되는 경우를 제외하고는 언제든지 회사의 정보 제공을
						위한 이메일의 수신을 거절할 수 있습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 24 조 (회원정보활용 및 마케팅 이용 동의)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회원은 회사가 제공하는 서비스의 원활한 수행을 위하여 회원이 정보제공을 동의한 제3자에게 개별
						서비스 내에서 처리되는 다음의 각 호의 자료를 전송할 수 있도록 동의합니다.
						<ol className="terms-depth">
							<li className="depth">
								<span>1)</span>업체명, 사업자번호, 법인번호 등 사업자의 개황에 관한 사항
							</li>
							<li className="depth">
								<span>2)</span>대차대조표, 손익계산서, 제조원가명세서 등 주요 재무제표
							</li>
							<li className="depth">
								<span>3)</span>부가가치세 신고서와 세금계산서 합계표 상의 부가가치세 정보
							</li>
							<li className="depth">
								<span>4)</span>연혁, 매출구성, 주주구성, 경영진현황 등
							</li>
							<li className="depth">
								<span>5)</span>기타 서비스 제공을 위해 제3자에게 제공할 필요가 있는 자료
							</li>
						</ol>
					</li>
					<li className="depth">
						<span>2.</span>회사는 관계법령이 정한 방법과 절차에 따라 서비스 제공과 관련하여 취득한 회원 정보를 다음 각
						호와 같이 활용할 수 있습니다.
						<ol className="terms-depth">
							<li className="depth">
								<span>1)</span>회원에게 제공한 개별 서비스의 기능향상 내지 최적화 또는 고객 지향적인 서비스제고를 위한
								연구 개발의 목적으로 특정한 정보주체를 식별할 수 없는 형태로 활용
							</li>
							<li className="depth">
								<span>2)</span>통계작성 및 학술 연구 시장조사를 위한 목적으로 특정한 정보주체를 식별할 수 없는 형태로
								활용
							</li>
							<li className="depth">
								<span>3)</span>회원에게 유용한 정보제공, 선별적인 광고노출 등을 구현하기 위한 데이터 분석 목적으로 활용
							</li>
							<li className="depth">
								<span>4)</span>회원에 대한 금융지원서비스 제공 및 기업신용도를 평가를 위한 연구, 개발 목적으로 특정한
								정보주체를 식별할 수 없는 형태로 활용
							</li>
							<li className="depth">
								<span>5)</span>위 각호의 연구 등을 신용정보업체 또는 금융기관, 연구소 등과 공동수행하기 위한 목적으로
								특정한 정보주체를 식별할 수 없는 형태로 활용
							</li>
							<li className="depth">
								<span>6)</span>서비스 제공에 따른 요금정산 등 서비스 이용계약 이행을 위하여 필요한 경우 활용
							</li>
						</ol>
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 25 조 (양도금지)</h4>
				<p>
					회원은 서비스의 이용권한, 기타 이용 계약상 지위를 회사의 동의 없이 타인에게 양도, 증여, 판매, 담보 제공 등의
					처분 행위를 할 수 없습니다.
				</p>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 26 조 (손해배상 등)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사 또는 회원이 본 약관에서 정한 의무를 위반함에 따라 상대방에게 손해가 발생한 경우, 귀책당
						사자에게 손해배상을 청구할 수 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>본 약관에서 정한 의무 위반 등으로 인하여 제3자와의 분쟁 발생 시 귀책당사자는 자신의 책임과
						비용으로 상대방을 면책시키고, 그로 인한 상대방의 모든 손해를 배상하여야 합니다.
					</li>
					<li className="depth">
						<span>3.</span>회사가 무료로 제공하는 서비스의 이용과 관련하여 회원에게 발생한 손해에 대해서는 회사는 책임
						을 지지 않습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 27 조 (면책조항)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 및 기타 이에 준하는 불가항력으로 인하여
						서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임을 지지 않습니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 회원의 귀책사유로 인한 서비스 이용의 장애 또는 손해에 대해서 어떤 책임도 부담하지
						않습니다.
					</li>
					<li className="depth">
						<span>3.</span>회사가 제공하는 정보와 자료는 거래의 목적으로 이용될 수 없습니다. 또한, 회사는 서비스 자료에
						대한 취사 선택 또는 이용으로 회원에게 발생하는 손해 등에 대해서는 책임이 면제됩니다.
					</li>
					<li className="depth">
						<span>4.</span>회사는 사용자가 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여 책임을
						지지 않습니다. 또한 회사는 회원이 서비스를 이용하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.
					</li>
					<li className="depth">
						<span>5.</span>회사는 회원 상호 간, 또는 회원과 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대해서는 개입할
						의무가 없으며 이로 인한 어떠한 손해를 배상할 책임이 없습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 28 조 (서비스하자 등에 의한 이용자피해보상)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 서비스하자 등에 의한 이용자피해보상의 기준·범위·방법 및 절차에 관한 사항을 콘텐츠이용
						자 보호지침에 따라 처리합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 29 조 (준거법 및 관할법원)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사와 회원은 서비스와 관련하여 분쟁이 발생할 경우, 이를 원만하게 해결하기 위하여 필요한 모
						든 노력을 하여야 합니다.
					</li>
					<li className="depth">
						<span>2.</span>서비스 이용과 관련해 발생한 분쟁이 원만하게 해결되지 아니한 경우 관련 소송의 관할법원은 회사
						의 본점 소재지를 관할하는 법원으로 합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 30조 (기타)</h4>
				<p>본 약관에서 정하지 않은 사항 및 내용 해석상의 이견이 있을 경우에는 일반 상관습에 따르기로 합니다.</p>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">[부칙]</h4>
				<p>1. 본 약관은 2025년 04월 10일부터 적용됩니다. </p>
				<p>2. 개정된 이용약관의 적용일자 이전 가입자 또한 개정된 이용약관의 적용을 받습니다.</p>
			</div>
			<div className="terms-box">
				<p>최초 시행일자: 2025년 04월 10일</p>
			</div>
		</div>
	);
};

export default Terms250410;
